/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function normalizeEvent(events) {
  return Array.isArray(events) ? events : [events];
}
var _default = normalizeEvent;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Overlay/src/utils/normalizeEvent.js
// module id = 735
// module chunks = 0